import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RunningSubscriptionListItem } from './running-subscription-list-item.model';

@Component({
  selector: 'shared-running-subscription-list',
  templateUrl: './running-subscription-list.component.html',
  styleUrl: './running-subscription-list.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RunningSubscriptionListComponent {
  @Input() items: RunningSubscriptionListItem[] = [];
  @Output() readonly itemClick =
    new EventEmitter<RunningSubscriptionListItem>();

  onItemClick(item: RunningSubscriptionListItem): void {
    this.itemClick.emit(item);
  }
}
